import React, {useState} from 'react';
import {Container, Typography, TextField, Button, Box} from '@mui/material';
import {useAppDispatch, useAppSelector} from '../../app/hooks';
import {login, updatePassword} from './authSlice';
import {Controller, useForm} from "react-hook-form";
import ForgotPasswordForm from './ForgotPasswordForm/ForgotPasswordForm';

interface ILoginFormData {
    email: string,
    password: string,
    code: string
}

const LoginPage: React.FC = () => {
    const [isOpenForgotForm, setIsOpenForgotForm] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    const {handleSubmit, control, setValue} = useForm<ILoginFormData>({
        defaultValues: {
            email: '',
            password: '',
            code: '',
        }
    });
    const {isSentCode} = useAppSelector((state) => state.auth);


    const onSubmit = (data: ILoginFormData) => {
        if (isSentCode) {
            dispatch(updatePassword({
                email: data.email,
                password: data.password,
                codeFromEmail: data.code
            }));

        } else {
            dispatch(login({
                email: data.email,
                password: data.password,
            }));
        }
    };


    return (
        <Container>
            {
                isOpenForgotForm &&
                <ForgotPasswordForm
                    closeForm={() => setIsOpenForgotForm(false)}
                    resetPassword={() => setValue("password", "")}
                />
            }
            <Container maxWidth="xs" sx={{mt: 8}}>
                <Typography variant="h4" align="center" gutterBottom>
                    Login
                </Typography>
                <Box
                    component="form"
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        <Controller
                            control={control}
                            name={"email"}
                            defaultValue={""}
                            rules={{
                                required: true,
                                minLength: 2,
                                maxLength: 150,
                                pattern: {
                                    value: /[^\s]/,
                                    message: "Field can not contain only spaces"
                                }
                            }}
                            render={({
                                         field: {onChange, value},
                                         formState: {errors},
                                     }) => (
                                <TextField
                                    sx={{pb: "30px"}}
                                    label="Email"
                                    value={value}
                                    onChange={(e) => {
                                        onChange(e)
                                    }}
                                    error={Boolean(errors.email)}
                                    helperText={
                                        errors.email && errors.email.type === "required"
                                        && <span>Email is required</span>
                                        ||
                                        errors.email && errors.email.type === "maxLength"
                                        && <span>This field can not contain more than 150 symbols</span>
                                        ||
                                        errors.email && errors.email.type === "minLength"
                                        && <span>This field can not contain less than 2 symbols</span>
                                        ||
                                        errors.email && errors.email.type === "pattern"
                                        && <span>Field can not contain only spaces</span>
                                    }
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            defaultValue={""}
                            name={"password"}
                            rules={{
                                required: true,
                                minLength: 2,
                                maxLength: 150,
                                pattern: {
                                    value: /[^\s]/,
                                    message: "Field can not contain only spaces"
                                }
                            }}
                            render={({
                                         field: {onChange, value},
                                         formState: {errors},
                                     }) => (
                                <TextField
                                    label={isSentCode ? "New password" : "Password"}
                                    value={value}
                                    onChange={(e) => {
                                        onChange(e)
                                    }}
                                    type="password"
                                    error={Boolean(errors.password)}
                                    helperText={
                                        errors.password && errors.password.type === "required"
                                        && <span>Password field is required</span>
                                        ||
                                        errors.password && errors.password.type === "maxLength"
                                        && <span>This field can not contain more than 150 symbols</span>
                                        ||
                                        errors.password && errors.password.type === "minLength"
                                        && <span>This field can not contain less than 2 symbols</span>
                                        ||
                                        errors.password && errors.password.type === "pattern"
                                        && <span>Field can not contain only spaces</span>
                                    }
                                />
                            )}
                        />
                        {isSentCode &&
                            <Controller
                                control={control}
                                name={"code"}
                                rules={{required: true}}
                                render={({
                                             field: {onChange, value},
                                             formState: {errors},
                                         }) => (
                                    <TextField
                                        sx={{mt: "30px"}}
                                        label="Code"
                                        value={value}
                                        onChange={(e) => {
                                            onChange(e)
                                        }}
                                        error={Boolean(errors.code)}
                                        helperText={
                                            errors.code && errors.code.type === "required"
                                            && <span>Code field is required</span>
                                        }
                                    />
                                )}
                            />
                        }
                        <Box
                            sx={{
                                pt: "5px",
                                mb: "30px",
                                display: "flex",
                                justifyContent: "end"
                            }}
                        >
                            <Button
                                onClick={() => setIsOpenForgotForm(true)}
                            >
                                Forgot password?
                            </Button>
                        </Box>
                        <Button variant="contained" type="submit">
                            Submit
                        </Button>
                    </Box>
                </Box>
            </Container>
        </Container>
    );
};

export default LoginPage;
